import { z } from 'zod'
import { oc } from '@orpc/contract'

const practitionerOpsOrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  // The Organization's Group NPI and TIN as bare digits; absent when it has none on file.
  npi: z.string().optional(),
  taxId: z.string().optional(),
})

export type PractitionerOpsOrganization = z.infer<typeof practitionerOpsOrganizationSchema>

/**
 * The Organizations the caller may run Provider Operations for, ordered by name: every
 * practice Organization for a super admin, the Organizations where the caller holds the Care
 * Coordinator role otherwise, and empty for everyone else (a physician, a Call Center
 * Manager). The web shows the nav entry and admits `/providers` exactly when this is
 * non-empty, and renders the Organization dropdown when it has more than one entry.
 */
export const getMyPractitionerOpsScope = oc
  // `me/…`, like `/v2/patient/me/…`: a one-segment literal under `/v2/practitioners/` would be
  // matched by `GET /v2/practitioners/{practitionerId}` with "scope" as the id.
  .route({ method: 'GET', path: '/v2/practitioners/me/scope' })
  .output(z.object({ organizations: z.array(practitionerOpsOrganizationSchema) }))
